import styled from 'styled-components'

import { BackgroundContainer } from '@reveni-io/reveni-ui'

export const Layout = styled(BackgroundContainer)`
  display: flex;
  flex-direction: column;
  justify-content: ${props => (props.headerAboveCard ? 'flex-start' : 'center')};
  align-items: center;
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: ${props => props.theme.whiteLabel.spacing.sp16};
  background-color: ${props => props.theme.colors.grey.tone50};

  & > div {
    margin-top: ${props => props.theme.whiteLabel.spacing.sp24};
    margin-bottom: ${props => props.theme.whiteLabel.spacing.sp16};
    width: 436px;
    padding: ${props => props.theme.whiteLabel.spacing.sp32} ${props => props.theme.whiteLabel.spacing.sp24};
    box-sizing: border-box;
  }

  @media screen and (max-width: 436px) {
    & > div {
      width: 100%;
    }
  }
`

export const HeaderContainer = styled.div`
  padding: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
`

export const LanguageSelectorContainer = styled.div`
  width: 100px !important;
  margin-top: 0 !important;
  padding: 0 !important;
`
